import React from 'react';
import { PlanogramComplianceResponse } from '../types';

interface ModFiltersProps {
  allTagNames: string[];
  enabledMods: Set<string>;
  toggleMod: (tagName: string) => void;
  planogramComplianceData?: PlanogramComplianceResponse | null;
}

export const ModFilters: React.FC<ModFiltersProps> = ({
  allTagNames,
  enabledMods,
  toggleMod,
  planogramComplianceData,
}) => {
  const complianceKeys = planogramComplianceData
    ? Object.keys(planogramComplianceData.pogCompliance)
    : [];

  return (
    <>
      <div className="flex flex-wrap gap-2">
        <span className="text-sm font-medium text-gray-700 mr-2 flex items-center">Mods:</span>
        {allTagNames.map((tagName) => (
          <button
            key={tagName}
            onClick={() => toggleMod(tagName)}
            className={`px-3 py-1 rounded-full text-sm transition-colors ${
              enabledMods.has(tagName)
                ? 'bg-blue-500 text-white'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            {tagName}
          </button>
        ))}
      </div>
      {planogramComplianceData &&
        planogramComplianceData.osaCompliance &&
        planogramComplianceData.pogCompliance && (
          <div className="bg-black/70 text-white text-xs rounded px-2 py-1 backdrop-blur-sm flex flex-col items-end gap-1">
            <div
              className={`flex whitespace-nowrap ${
                complianceKeys.length > 2 ? 'gap-2 flex-col 2xl:flex-row 2xl:gap-4' : 'gap-4'
              }`}
            >
              {complianceKeys.sort().map((key) => (
                <span key={key}>
                  <strong>POG:</strong>{' '}
                  {Math.round((planogramComplianceData.pogCompliance[key] ?? 0) * 100)}% |{' '}
                  <strong>OSA:</strong>{' '}
                  {Math.round((planogramComplianceData.osaCompliance[key] ?? 0) * 100)}%
                </span>
              ))}
            </div>
          </div>
        )}
    </>
  );
};
